import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Deck } from '@deckplan.io/common';
import { DecksService } from '../decks.service';
import { Format } from '../formats/format.interface';
import { MatDialog } from '@angular/material/dialog';
import { CardActionTaken, CardViewComponent, CardViewDialogData } from '../../cards/card-view/card-view.component';
import { FormatFactory } from '../formats/format-factory';

@Component({
    selector: 'app-deck-summary',
    templateUrl: './deck-summary.component.html',
    styleUrls: ['./deck-summary.component.scss']
})
export class DeckSummaryComponent implements OnInit, OnChanges {

    @Input() public deck: Deck;
    @Input() public format: Format;
    @Input() public cardsRemovable = true;

    public removableCards: boolean | { deckId: string };

    @Output() public cardActionTaken = new EventEmitter();

    public summary: any = {};
    public namesToCard: any = {};
    public invalidCards = new Set<string>();

    private readonly typeMappings = {
        '.*Creature.*': 'Creature',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Artifact|Legendary Artifact': 'Artifact',
        '.*Enchantment.*': 'Enchantment',
        '.*Land.*': 'Land',
        '.*Planeswalker.*': 'Planeswalker',
        '.*Plane.*': 'Plane',
        '.*Conspiracy.*': 'Conspiracy',
        '.*Instant.*': 'Instant',
        '.*Phenomenon.*': 'Phenomenon',
        '.*Scheme.*': 'Scheme',
        '.*Sorcery.*': 'Sorcery',
        '.*Tribal.*': 'Tribal',
        '.*Vanguard.*': 'Vanguard'
    } as any;

    constructor(private readonly decksService: DecksService, private readonly dialog: MatDialog) { }

    public ngOnInit(): void {
        if (this.cardsRemovable) {
            this.removableCards = {deckId: this.deck.id};
        } else {
            this.removableCards = false;
        }

        this.getSummary();
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.getSummary();
    }

    private getSummary() {
        const format = FormatFactory.create(this.deck, null, null, true);
        this.decksService.get(this.deck.id, format.deckCardsQuery()).subscribe(deck => {
            this.summary = {};
            for (const card of deck.cards) {
                let simpleType = card.type.split(' — ')[0];
                for (const key in this.typeMappings) {
                    if (this.typeMappings.hasOwnProperty(key) && simpleType.match(key)) {
                        simpleType = this.typeMappings[key];
                        break;
                    }
                }
                if (this.summary.hasOwnProperty(simpleType) && this.summary[simpleType].hasOwnProperty(card.name)) {
                    this.summary[simpleType][card.name] += card.quantityInDeck || 1;
                } else if (!this.summary.hasOwnProperty(simpleType)) {
                    this.summary[simpleType] = {};
                    this.summary[simpleType][card.name] = card.quantityInDeck || 1;
                } else {
                    this.summary[simpleType][card.name] = card.quantityInDeck || 1;
                }
                this.namesToCard[card.name] = card;
            }

            // Get the format rules for our deck type
            this.invalidCards = new Set<string>(this.format ? this.format.validate().map(card => card.name) : []);
        });
    }

    public countType(type: string) {
        let count = 0;
        for (const key in this.summary[type]) {
            if (this.summary[type].hasOwnProperty(key)) {
                count += this.summary[type][key];
            }
        }
        return count;
    }

    public cardFor(type: string, cardName: string) {
        const count = this.summary[type][cardName];
        // TODO: pass count to CardView
        const data = {
            card: this.namesToCard[cardName],
            removable: this.removableCards,
            addToDeck: false,
            addToInventory: true,
            quantity: count
        } as CardViewDialogData;
        const dialogRef = this.dialog.open(CardViewComponent, { data, minWidth: '600px' });
        dialogRef.componentInstance.actionTaken.subscribe(action => {
            this.getSummary();
            if (action === CardActionTaken.Removed) {
                dialogRef.close();
            }
            this.cardActionTaken.emit();
        });
    }

}
